import React, { useEffect, useState, useReducer } from "react";
import { Link } from "react-router-dom";
import { getData } from "app/data";
import LangSelect from "components/LangSelect";
import Logo from "images/goopter-logo.png";
import { ReactComponent as CloseBtn } from "images/icons/close-mobile.svg";
import { FormattedMessage } from "react-intl";
import { formatText } from "util/helper";
import ModalContentList from "./ModalContent/ModalContentList";
import MobileMenuButton from "./MobileMenuButton/MobileMenuButton";
import SingleNavMenu from "./NavMenu/SingleNavMenu";
import ParentNavMenu from "./NavMenu/ParentNavMenu";
import NavItemsMobile from "./NavMenuMobile/NavItemsMobile";
import classes from "./Header.module.css";

const initialState = {};
const INIT_MENU_STATE = "INIT_MENU_STATE";
const OPEN_MENU_STATE = "OPEN_MENU_STATE";
const CLOSE_ALL_MENU_STATE = "CLOSE_ALL_MENU_STATE";

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_MENU_STATE: {
      return {
        ...state,
        navMenuItemOrderIdList: action.navMenuItemOrderIdList,
        navMenuItemList: action.navMenuItemList,
      };
    }

    case CLOSE_ALL_MENU_STATE: {
      // update all menu item status to closed
      let updatedNavMenuItemList = { ...state.navMenuItemList };
      for (let key in updatedNavMenuItemList) {
        updatedNavMenuItemList[key].isOpen = false;
      }

      return {
        ...state,
        navMenuItemList: updatedNavMenuItemList,
      };
    }

    case OPEN_MENU_STATE: {
      // update target menu state open
      let updatedNavMenuItemList = {
        ...state.navMenuItemList,
        [action.id]: { ...state.navMenuItemList[action.id], isOpen: true },
      };

      return {
        ...state,
        navMenuItemList: updatedNavMenuItemList,
      };
    }

    default:
      return state;
  }
};

export default function Index(props) {
  // menu data from WP api
  const menu = props.menu;
  const [menuState, dispatchMenuState] = useReducer(menuReducer, initialState);

  // state for menu
  const [modalTitle, setModalTitle] = useState();
  const [modalContents, setModalContents] = useState();
  const [navOpen, setNavOpen] = useState(false);
  const [childDrop1IsOpen, setChildDrop1IsOpen] = useState(false);
  const [childDrop2IsOpen, setChildDrop2IsOpen] = useState(false);

  const showChildMenuHandler = menuId => {
    dispatchMenuState({ type: CLOSE_ALL_MENU_STATE });
    dispatchMenuState({ type: OPEN_MENU_STATE, id: menuId });
  };

  const closeChildMenuHandler = () => {
    dispatchMenuState({ type: CLOSE_ALL_MENU_STATE });
  };
  const showModalsHandler = (data, index) => {
    const id = data.ID;
    setModalTitle(
      index === 0 ? "nav_modal_title_software" : "nav_modal_title_hardware"
    );
    setModalContents(getData("navModal")[id]);
    if (index === 0) setChildDrop1IsOpen(true);
    else if (index === 1) setChildDrop2IsOpen(true);
  };

  const closeModalsHandler = index => {
    if (index === 0) setChildDrop1IsOpen(false);
    else if (index === 1) setChildDrop2IsOpen(false);
  };

  const modalHrefHandler = index => {
    if (index === 0) {
      window.location.href = "/software-solution";
    } else if (index === 1) {
      window.location.href = "/hardware-solution";
    }
  };

  const initMenuItemList = () => {
    let navMenuItemList = {};
    let navMenuItemOrderIdList = [];
    menu.forEach(menuItem => {
      const NO_PARENT_ID = "0";
      if (menuItem.menu_item_parent === NO_PARENT_ID) {
        // parent menu
        navMenuItemList[menuItem.ID] = menuItem;
        navMenuItemList[menuItem.ID].children = [];
        navMenuItemList[menuItem.ID].isOpen = false;
        navMenuItemOrderIdList.push(menuItem.ID);
      } else {
        // child menu
        const parentId = menuItem.menu_item_parent;
        if (navMenuItemList[parentId]) {
          navMenuItemList[parentId].children.push(menuItem);
        }
      }
    });

    dispatchMenuState({
      type: INIT_MENU_STATE,
      navMenuItemOrderIdList,
      navMenuItemList,
    });


  };

  useEffect(() => {
    initMenuItemList();
  }, [menu]);

  const desktopNav = (
    <div className={classes["desktop-nav"]}>
      {menuState.navMenuItemOrderIdList
        ? menuState.navMenuItemOrderIdList.map((navMenuItemOrderId, index) => {
          if (
            menuState.navMenuItemList[navMenuItemOrderId].children.length < 1
          ) {
            return (
              <SingleNavMenu
                menuItem={menuState.navMenuItemList[navMenuItemOrderId]}
              />
            );
          } else {
            return (
              <ParentNavMenu
                item={menuState.navMenuItemList[navMenuItemOrderId]}
                index={index}
                showChildMenuHandler={showChildMenuHandler}
                closeChildMenuHandler={closeChildMenuHandler}
                closeModalsHandler={closeModalsHandler}
                showModalsHandler={showModalsHandler}
                childDrop1IsOpen={childDrop1IsOpen}
                childDrop2IsOpen={childDrop2IsOpen}
                modalHrefHandler={modalHrefHandler}
                modalTitle={modalTitle}
                modalContents={modalContents}
                ModalContentList={ModalContentList}
              />
            );
          }
        })
        : null}
    </div>
  );

  const mobileNav = (
    <div
      className={`${classes["mobile-nav"]} ${navOpen ? classes["open"] : ""}`}
    >
      <div className={classes["mobile-nav--header"]}>
        <div className={classes["mobile-nav--logo"]}>
          <Link to="/" onClick={() => setNavOpen(false)}>
            <img src={Logo} alt="logo" />
          </Link>
        </div>
        <div className={classes["mobile-nav--close-button"]}>
          <a onClick={() => setNavOpen(false)}>
            <CloseBtn />
          </a>
        </div>
      </div>
      <NavItemsMobile
        navMenuItemOrderIdList={menuState.navMenuItemOrderIdList}
        navMenuItemList={menuState.navMenuItemList}
        setNavOpen={setNavOpen}
        showModalsHandler={showModalsHandler}
        modalContents={modalContents}
        LangSelect={LangSelect}
      />
    </div>
  );

  return (
    <header className={classes["main-header"]}>
      <div className={classes.logo}>
        <Link to="/">
          <img src={Logo} alt="logo" />
        </Link>
      </div>

      {desktopNav}

      <div className={classes["desktop-nav--sub-menu"]}>
        <LangSelect />
        {/* <div className={classes["desktop-nav--divider"]}></div>
        <Link className={classes.signup} to="/signup">
          <FormattedMessage id={formatText("sign_up")} />
        </Link>
        <Link
          to="/request-a-demo"
          className={"green-button" + " " + classes["desktop-nav--button"]}
        >
          <FormattedMessage id={formatText("request_a_demo")} />
        </Link> */}
      </div>

      <MobileMenuButton setNavOpen={setNavOpen} />
      {mobileNav}
    </header>
  );
}
